import { c as _c } from "react/compiler-runtime";
import { type Icon, IcoWarning16 } from '@onefootprint/icons';
import { MarkdownText } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { containsListOrBlockquoteMarkdown, containsNonInlineMarkdown } from './contains-markdown';
type PromptWithGuidelinesProps = {
  icon?: Icon;
  guidelines: string[];
  title: string;
  description?: string;
  alertMessage?: string;
  variant?: 'default' | 'error';
};
const PromptWithGuidelines = t0 => {
  const $ = _c(25);
  const {
    icon: Icon,
    guidelines,
    description,
    alertMessage,
    title,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== Icon || $[1] !== variant) {
    t2 = Icon && <Icon color={variant === "error" ? "error" : "primary"} />;
    $[0] = Icon;
    $[1] = variant;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = variant === "error" ? "text-error" : "text-primary";
  let t4;
  if ($[3] !== t3) {
    t4 = cx("text-label-1", t3, "text-center fp-text");
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4 || $[6] !== title) {
    t5 = <p className={t4}>{title}</p>;
    $[5] = t4;
    $[6] = title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== description) {
    t6 = description && <div className={`text-body-2 text-secondary ${!containsListOrBlockquoteMarkdown(description) && "text-center"} ${!containsNonInlineMarkdown(description) && "whitespace-pre-wrap"}`}><MarkdownText>{description}</MarkdownText></div>;
    $[8] = description;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="flex flex-col gap-2">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== guidelines) {
    t8 = guidelines.length > 0 && <div className={cx("flex flex-col justify-center items-center w-full gap-2 p-4", {
      "ps-8": guidelines.length > 1
    })}>{guidelines.length === 1 ? <p className="text-body-2 text-secondary text-center fp-text">{guidelines[0]}</p> : guidelines.map(_temp)}</div>;
    $[13] = guidelines;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== alertMessage || $[16] !== guidelines.length) {
    t9 = alertMessage && <div className={cx("flex justify-start gap-2 w-full py-3 px-4 border-t border-dashed border-tertiary rounded-b", guidelines.length > 0 ? "bg-secondary" : "bg-primary")} data-has-guidelines={guidelines.length > 0}><div className="flex justify-center items-center h-[21px]"><IcoWarning16 color="primary" /></div><p className="text-label-2 text-primary text-left fp-text">{alertMessage}</p></div>;
    $[15] = alertMessage;
    $[16] = guidelines.length;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="flex flex-col w-full bg-secondary rounded">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t2 || $[23] !== t7) {
    t11 = <div className="flex flex-col justify-center items-center gap-4 w-full">{t2}{t7}{t10}</div>;
    $[21] = t10;
    $[22] = t2;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};
export default PromptWithGuidelines;
function _temp(guideline) {
  return <li key={guideline} className="text-body-2 text-secondary text-left w-full fp-text">{guideline}</li>;
}